import { VueConstructor } from 'vue'
import ADMBase from '@/components/base/ADM.vue'
import ADMRouteMetaData from './adm-route-metadata.model'

export default class ADMRoute {
    path: string
    name: string
    component: VueConstructor
    parentName: string
    meta: ADMRouteMetaData

    constructor (
        { path, name, parentName, meta }:
        {
            path: string;
            name: string;
            parentName: string;
            meta: ADMRouteMetaData;
        }) {
        this.component = ADMBase
        this.path = path
        this.name = name
        this.parentName = parentName
        this.meta = meta
    }
}
